import _extends from "@babel/runtime/helpers/esm/extends";
var _circle, _path;
import React from 'react';
import { SvgIcon } from '@mui/material';
const RepublicOfPoland = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 512 512",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: "256",
  cy: "256",
  r: "256",
  fill: "#f0f0f0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256"
}))));
export default RepublicOfPoland;